const categoryColumns = [
  {
    label: 'Name',
    value: 'name',
    textId: 'fleetadmin.category.table.name',
    disabled: true,
  },
  {
    label: 'Acriss Code',
    value: 'acrissCode',
    textId: 'fleetadmin.category.table.acrisscode',
    disabled: false,
  },
  {
    label: 'Brand',
    value: 'brandId',
    textId: 'fleetadmin.category.table.brand',
    disabled: false,
  },
  {
    label: 'Description',
    value: 'description',
    textId: 'fleetadmin.category.table.description',
    disabled: false,
  },
  {
    label: 'No.Vehicles',
    value: 'id',
    textId: 'fleetadmin.category.table.novehicles',
    disabled: false,
  },
];

export const defaultSelectedCategoryColumns = categoryColumns.map(
  (categoryColumn) => categoryColumn.value
);

export default categoryColumns;
